
(function(template){
  define('vue!optionalClassProgram/components/userComponents/loggedInUserComponents/innerComponent',[
      "Vue",
      "helpers",
      "vuex",
      'vue!../../classComponents/mandatoryComponents/mandatoryClassComponent',
      'vue!../../classComponents/optionalComponents/optionalClassComponent',
      'vue!../../eventDetailComponent',


  ], function (
      Vue,
      helpers,
      vuex,
      mandatoryClassComponent,
      optionalClassComponent,
      eventDetailComponent
  ) {
      return {
          template: template,
          name: "",
          props: ['lgIndex', 'customerID'],
          data: function () {
              return {
              }
          },
          computed: _.extend(
              vuex.mapState(['users', 'usersWithIds', 'currentlyBookingClassProgram']), {
            
              }),
  
          components: {
              'mandatoryClassComponent': mandatoryClassComponent,
              'optionalClassComponent': optionalClassComponent,
              'eventDetailComponent':eventDetailComponent
          }
      }
  })
})('<div> <div :id="\'lg\'+lgIndex" class="accordion-body collapse in"> <div> <eventDetailComponent v-bind:customerID="customerID"> </eventDetailComponent> <mandatoryClassComponent v-bind:customerID="customerID"> </mandatoryClassComponent> <optionalClassComponent v-bind:customerID="customerID"> </optionalClassComponent> </div> </div> </div>');
